import { LoadingOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// DS
import {
  Col,
  Form,
  VertInput,
  Row,
  VertTypography,
  VertLoading,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Forms/FormsStyles.less';
import 'Assets/styles/default/components/Profile/Profile.less';
import MaskedInput from 'pages/newSolicitation/components/InputMask';
import ynToBool from "Utils/ynToBool";
import isFakeEmail from "Utils/isFakeEmail"

// FORMS COMPANY DATA COMPONENT
const FormsCompanyData = ({ ...props }) => {
  const [useForm] = Form.useForm();
  const {
    onChange,
    form,
    isValid,
    clientHasIEValidation,
    stateInscriptionIsLoading,
    validateIeEmitter,
  } = props;

  const verifyEmail = props?.form?.email?.value;
  const fakeEmail = (ynToBool(process.env.REACT_APP_HIDE_FAKE_EMAIL) && isFakeEmail(verifyEmail)) ?
    { display: 'none' } : {};


  const handleChange = (name, value) => {
    const fieldsErros = useForm.getFieldsError();
    const hasValid = fieldsErros.find((a) => a.errors.length > 0)
      ? false
      : true;
    onChange(name, value);
    isValid({ companyData: hasValid });
  };
  const stateInscription = form.stateInscription?.value ?? 'ISENTO';

  const [disabledCpfPartner, setDisabledCpfPartner] = useState(true);

  useEffect(() => {
    if (form.stateInscription.value) {
      useForm.setFieldValue('stateInscription', stateInscription);
    }
  }, [form.stateInscription]);

  useEffect(() => {
    if (form) {
      useForm.setFieldsValue({
        companyName: form.name.value,
        documentNumber: form.documentNumber.value,
        partnerCpf: form.partnerCpf.value,
        phone: form.phone.value,
        email: form.email.value,
        stateInscription: stateInscription,
      });

      if (form.partnerCpf.disabled) {
        if (form.partnerCpf.value == '' || form.partnerCpf.value == null) {
          setDisabledCpfPartner(false);
          useForm.setFields([
            {
              name: 'partnerCpf',
              errors: ['CPF do sócio precisa ser preenchido.'],
            },
          ]);
        }
      } else {
        setDisabledCpfPartner(false);
      }
    }
  }, []);

  useEffect(() => {
    if (
      !form.partnerCpf.disabled &&
      (form.partnerCpf.value == '' || form.partnerCpf.value == null)
    ) {
      setDisabledCpfPartner(false);
      useForm.setFields([
        {
          name: 'partnerCpf',
          errors: ['CPF do sócio precisa ser preenchido.'],
        },
      ]);
    }
  }, [form.partnerCpf?.disabled, form.partnerCpf?.value]);

  useEffect(() => {
    const fieldsErros = useForm.getFieldsError();
    const hasValid = fieldsErros.find((a) => a.errors.length > 0)
      ? false
      : true;
    isValid({ companyData: hasValid });
  }, [useForm.getFieldError()]);

  return (
    <Col className="forms-method-payment-wrapper col-12 container-form-company-data">
      <div>
        <Row className="checkout-summary-title">
          <VertTypography.Title level={3} className="margin-bottom-small">
            Meus Dados
          </VertTypography.Title>
        </Row>
        <Form
          name="FormsCompanyData"
          form={useForm}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          initialValues={{ remember: true }}
          autoComplete="off"
          layout="vertical"
          className="form-company-data"
        >
          {/* Razão Social */}
          <div className="formItem">
            <Form.Item
              name="companyName"
              validateTrigger={['onBlur', 'onChange']}
              rules={[
                {
                  required: true,
                  message: 'Razão social precisa ser preenchido.',
                },
              ]}
            >
              <VertInput
                template="marketplace"
                label="Razão social"
                onChange={({ target }) =>
                  handleChange('companyName', target.value)
                }
                disabled={form.companyName.disabled}
              />
            </Form.Item>
          </div>
          {/* CNPJ _ IE */}

          <div className="company-data-container-documento-state-inscription">
            <div className="company-data-50-percent-container">
              <Form.Item
                name="documentNumber"
                validateTrigger={['onBlur', 'onChange']}
                rules={[
                  { required: true, message: 'CNPJ precisa ser preenchido.' },
                ]}
              >
                <MaskedInput
                  mask={'99.999.999/9999-99'}
                  label="CNPJ"
                  placeholder=""
                  prefix={<LoadingOutlined />}
                  template="marketplace"
                  disabled={form.documentNumber.disabled}
                  onChange={(e) => {
                    const value = e.replace(/[^0-9]/g, '');
                    if (value.length === 14) {
                      handleChange('documentNumber', value);
                    }
                  }}
                />
              </Form.Item>
            </div>

            <div className="company-data-50-percent-container">
              <Row align="middle">
                <Col span={stateInscriptionIsLoading ? 20 : 24}>
                  <Form.Item
                    name="stateInscription"
                    validateTrigger={['onBlur', 'onChange']}
                    rules={[
                      {
                        required: true,
                        message: 'Inscrição estadual precisa ser preenchido.',
                      },
                    ]}
                  >
                    <VertInput
                      template="marketplace"
                      label="Inscrição estadual"
                      disabled={
                        stateInscriptionIsLoading ||
                        form.stateInscription.disabled
                      }
                      onBlur={() =>
                        clientHasIEValidation
                          ? validateIeEmitter(
                            useForm.getFieldValue('stateInscription')
                          )
                          : {}
                      }
                      onChange={({ target }) =>
                        handleChange('stateInscription', target.value)
                      }
                    />
                  </Form.Item>
                </Col>

                {stateInscriptionIsLoading && (
                  <Col span={2}>
                    <VertLoading
                      size="small"
                      type="spin"
                      className="color-detached"
                    />
                  </Col>
                )}
              </Row>
            </div>
          </div>

          {/* CPF _ PHONE _ EMAIL */}
          <div className="formItem">
            <Form.Item
              name="partnerCpf"
              validateTrigger={['onBlur', 'onChange']}
              rules={[
                {
                  required: !disabledCpfPartner,
                  message: 'CPF do sócio precisa ser preenchido.',
                },
              ]}
            >
              <MaskedInput
                mask={'999.999.999-99'}
                label="CPF do Sócio"
                placeholder=""
                prefix={<LoadingOutlined />}
                template="marketplace"
                disabled={disabledCpfPartner}
                onChange={(e) => {
                  const value = e.replace(/[^0-9]/g, '');
                  if (value.length === 11) {
                    handleChange('partnerCpf', value);
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              name="phone"
              validateTrigger={['onBlur', 'onChange']}
              rules={[
                {
                  required: true,
                  message: 'Celular precisa ser preenchido.',
                },
              ]}
            >
              <MaskedInput
                mask={'(99) 99999-9999'}
                label="Celular"
                placeholder=""
                prefix={<LoadingOutlined />}
                template="marketplace"
                disabled={ynToBool(form.phone.disabled) || ynToBool(process.env.REACT_APP_BLOCK_EDIT_PHONE)}
                onChange={(e) => {
                  if (ynToBool(process.env.REACT_APP_BLOCK_EDIT_PHONE)) return;
                  const value = e.replace(/[^0-9]/g, '');
                  if (value.length === 11) {
                    handleChange('phone', value);
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              name="email"
              validateTrigger={['onBlur', 'onChange']}
              rules={[
                {
                  required: true,
                  message: 'Email precisa ser preenchido.',
                },
                { type: 'email', message: 'Email inválido' },
              ]}
              style={fakeEmail}
            >
              <VertInput
                template="marketplace"
                label="Email"
                disabled={form.email.disabled}
                onChange={({ target }) => handleChange('email', target.value)}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
    </Col>
  );
};

const type = PropTypes.shape({
  value: PropTypes.any,
  disabled: PropTypes.bool,
});

FormsCompanyData.propTypes = {
  form: PropTypes.shape({
    name: type,
    documentNumber: type,
    stateInscription: type,
    partnerCpf: type,
    phone: type,
  }),
  onChange: PropTypes.func,
  isValid: PropTypes.func,
};

export default FormsCompanyData;
